module.exports = __webpack_public_path__ + "static/media/carrelage.172edf4a.jpg";